import { createContext } from "react";
import type { ChatMessage } from "@/components/chat/MessageList";
import type { PendingImport } from "@/hooks/useChatStream";
import type { GetConversationsQuery } from "@/graphql/getConversations.api";

export interface DashboardChatContextType {
  messages: ChatMessage[];
  isStreaming: boolean;
  conversationId: string | null;
  pendingImport: PendingImport | null;
  sendMessage: (content: string, file?: File) => Promise<void>;
  stopStreaming: () => void;
  loadConversation: (id: string, msgs: ChatMessage[]) => void;
  startNewChat: () => void;
  clearPendingImport: () => void;
  historyOpen: boolean;
  setHistoryOpen: (open: boolean) => void;
  conversations: GetConversationsQuery["conversations"];
  handleNewChat: () => void;
  handleSelectConversation: (id: string) => void;
  handleDeleteConversation: (id: string) => void;
  handleRenameConversation: () => void;
}

export const DashboardChatContext = createContext<DashboardChatContextType | null>(null);
